import { ViewConfiguration } from '../../grid/gridView/types';
import { ColumnDetails } from '../../grid/types/common';

export interface ImportantMessagesWebComponentSchema {
  views: Array<ViewConfiguration<Column, ColumnKeys>>;
  allColumns: Array<ColumnDetails<Column, ColumnKeys>>;
  defaultViewProps: ViewConfiguration<Column, ColumnKeys>;
}

export enum ColumnKeys {
  NAME = 'name',
  TYPE = 'type',
  CRITICALITY = 'criticality',
  ENABLED = 'enabled',
  DISPLAY_START_TIME = 'displayStartTime',
}

//This also dictates the order of the columns
export enum Column {
  NAME = 0,
  TYPE = 1,
  CRITICALITY = 2,
  ENABLED = 3,
  DISPLAY_START_TIME = 4,
}

export enum Type {
  BANNER_MESSAGE = 0,
  CARD_MESSAGE = 1,
}

export enum Criticality {
  INFO = 0,
  WARNING = 1,
  CRITICAL = 2,
}

export interface ImportantMessageGridItem {
  _id: string;
  name: string;
  type: Type;
  criticality: Criticality;
  enabled: boolean;
  displayStartTime: string;
  displayEndTime: string;
}

export interface GetDataGridItemsResponse {
  rawEvents?: Array<ImportantMessageGridItem>; // RawEvents is how gz-grid-view names its data
}
